import {
  // GET_FILTERS,
  GET_FILTERS_FAIL,
  GET_FILTERS_SUCCESS,
  APPLY_FILTER_PROPERTY,
  APPLY_FILTER_PROPERTY_FAIL,
  APPLY_FILTER_PROPERTY_SUCCESS,
  APPLY_FILTER_BLOCK,
  APPLY_FILTER_BLOCK_FAIL,
  APPLY_FILTER_BLOCK_SUCCESS,
  RESTORE_FILTER_PROPERTY
} from "./actionTypes"

const INIT_STATE = {
  filters: [],
  error: {},
  filterProperty: null,
  filterBlock: null,
}

const filters = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FILTERS_SUCCESS:
      
      if(state.filterBlock) {
        return {
        ...state,
        filters: action.payload,
      }
    }
    else {
      return {
        ...state,
        filters: action.payload,
        filterProperty: action.payload[0],
        filterBlock: action.payload[0].blocks[0],
      }
    }

    case GET_FILTERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

      case APPLY_FILTER_PROPERTY:
        return {
          ...state,
          filterProperty: action.payload,
          filterBlock: null,
        }

    case APPLY_FILTER_PROPERTY_SUCCESS:
      return {
        ...state,
        filters: [...state.filters, {
          filterProperty: action.payload,
          filterBlock: null,
        }],
      }

    case APPLY_FILTER_PROPERTY_FAIL:
      return {
        ...state,
        error: action.payload,
      }


    case APPLY_FILTER_BLOCK:
      return {
        ...state,
        filterBlock: action.payload,
      }

    case APPLY_FILTER_BLOCK_SUCCESS:
      return {
        ...state,
        filters: [...state.filters, {filterBlock: action.payload}],
      }

    case APPLY_FILTER_BLOCK_FAIL:
      return {
        ...state,
        error: action.payload,
      }
  

    default:
      return state
  }
}

export default filters
